import { SelectButton as LumXSelectButton } from '@lumapps/lumx/react';

import { SelectButton as BaseSelectButton } from './SelectButton';

export type { SelectButtonProps } from './SelectButton';
export type {
    SingleSelectButtonProps,
    MultipleSelectButtonProps,
    SelectButtonTranslations,
    SelectTextFieldStatus,
} from '@lumapps/lumx/react';

/**
 * A Button with a select dropdown to choose between a list of options.
 *
 * Wraps `@lumx/react`'s `SelectButton` and injects monorepo-default
 * translations for screen-reader announcements.
 *
 * @family Combobox
 */
export const SelectButton = Object.assign(BaseSelectButton, { Option: LumXSelectButton.Option });
